import { RefObject, useEffect, useMemo, useState } from "react"
import debounce from "lodash/debounce"

function collectVisibleRows(container: HTMLElement): string[] {
    const scrollTop = container.scrollTop
    const bottom = scrollTop + container.offsetHeight
    const ids: string[] = []
    const selector = ":scope > table > tbody > tr[data-item-id]"

    for (const row of container.querySelectorAll(selector)) {
        if (row instanceof HTMLTableRowElement && row.offsetTop >= scrollTop) {
            if (row.offsetTop + row.offsetHeight > bottom) {
                break
            }

            const jobId = row.getAttribute("data-item-id")

            if (jobId !== null) {
                ids.push(jobId)
            }
        }
    }

    return ids
}

export function useVisibleTableRows(
    scrollableRef: RefObject<HTMLElement>,
    items: unknown[] | undefined
): string[] {
    const [ids, setIds] = useState<string[]>([])
    const handleScroll = useMemo(
        () =>
            debounce(() => {
                if (scrollableRef.current !== null) {
                    setIds(collectVisibleRows(scrollableRef.current))
                }
            }, 100),
        [scrollableRef]
    )

    useEffect(() => {
        const scrollable = scrollableRef.current

        if (scrollable === null) {
            return
        }

        scrollable.addEventListener("scroll", handleScroll)
        setIds(collectVisibleRows(scrollable))

        return () => scrollable.removeEventListener("scroll", handleScroll)
    }, [scrollableRef, handleScroll])

    useEffect(() => {
        if (scrollableRef.current === null) {
            return
        }

        setIds(collectVisibleRows(scrollableRef.current))
    }, [items, scrollableRef])

    return ids
}
